import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import FormContext from "../../../context/form-context";
import { getSubmittedFormByID } from "../../../services/firebase/submittedForms/tb_submittedForms";
import { setAgentDetails, setAlert, setFormSignatories, setFormState } from "../../../state/action";
import { downloadFileByURL,  viewPDFFile } from "../pdfUtil";
import { PDFDocument } from "pdf-lib";
import { fetchPDFTemplateById } from '../../../services/firebase/pdfTemplates/tb_pdfTemlates';
import { checkIfFileExists } from "../../../services/real-star-api/file/file-checker";
import { ALERT_TYPE } from "../../../constants/alert-type";
import { decryptData, getExistingFileName, getFileExtension, isEmptyObject } from "../../../utils/utilities";
import dayjs from "dayjs";
import { ROLES } from "../../../constants/roles";


const usePublicPDFPage = () => {
    const { transID, formID , encryptedDate , type } = useParams();
    const { appState, dispatch } = useContext(FormContext)
    const { formSignatories, agentDetails } = appState;
    const { mainValues } = appState.formState;
    const [sharedTemplate, setSharedTemplate] = useState({})
    const [isMounted, setIsMounted] = useState(false)
    const [expirationDate, setExpirationDate] = useState("")
    const navigate = useNavigate();

    const agentValues = agentDetails

    useEffect(() => {

        const date = encryptedDate.replaceAll('xxx', '/')
        const encryptedGivenDate = decryptData(date); //to avoid conflict of slash on router
        console.log(encryptedGivenDate)
        const daysOfExpiration = 3;
        const expirationDate = dayjs(encryptedGivenDate).add(daysOfExpiration , "day").format("MM-DD-YYYY");
        console.log(`Expiration date of the given link: ${expirationDate}`)
        const dateToday = dayjs(new Date()).format("MM-DD-YYYY");
        
        if (!encryptedGivenDate) {
            dispatch(setAlert({ show: true, title: "Invalid Link", body: "The link does not exist." }))
            // navigate('/UnauthorizedAccess')
        }
        else if (encryptedGivenDate && (dateToday !== expirationDate)) {
            setExpirationDate(`${dayjs(expirationDate).format("DD-MMM-YYYY")}`)

            const getFormDetails = async () => {
                try{
                    const result = await getSubmittedFormByID(transID, "",ROLES.HQ) //hardcoded to HQ for public view
                   
                    if(isEmptyObject(result)){
                        dispatch(setAlert({
                            show: true,
                            title: "Unauthorized Access",
                            body: `You don't have permission for this transaction`,
                        }))
                        setIsMounted(false)
                        return
                    }

                    dispatch(setFormSignatories(result?.FormSignatories))
                    dispatch(setFormState(result?.Values))
                    dispatch(setAgentDetails(result?.Agent))
                }catch (error) {
                    alert(error)
                }

            }


            const getTemplateDetails = async () => {
                if(type==="0"){
                    const pdfTemplate = await fetchPDFTemplateById(formID);
                    setSharedTemplate({
                        Id: pdfTemplate.Id,
                        FormName: pdfTemplate.FormName, 
                        LocalPath: pdfTemplate.LocalPath,
                    })
                }else{
                    setSharedTemplate({                                
                        FormName: formID,
                        // FileType: file.type,
                        FileExtension: getFileExtension(formID)
                    })
                }

            }

            getTemplateDetails();
            getFormDetails();
            setIsMounted(true)
        }
        else {
            dispatch(setAlert({ show: true, title: "Expired Link", body: "The link you have has already expired." }))
            navigate('/UnauthorizedAccess')
        }


    }, [])

    const handleViewFile = async (file) => {

        try {
            console.log('Processing the file ...')

            const fileExtension = getFileExtension(file?.FormName);
            const existingFileName = getExistingFileName(file?.FormName)
            const newFileName = file?.FormName;
           
            const existingFileURL = await checkIfFileExists(transID, existingFileName);

            // from upload
            if (existingFileURL) {
                const cacheBustingURL = `${existingFileURL}?t=${new Date().getTime()}`
                const response = await fetch(cacheBustingURL);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                try {
                    const templateURL = await response?.url;
                    
                    if(fileExtension === "" || fileExtension === "pdf"){
                        window.open(`${templateURL}#toolbar=0&navpanes=0&scrollbar=0`, '_blank', 'width=800,height=800');
                    }else{
                        // for supporting docs
                        // await downloadFileByURL(templateURL, newFileName)
                        window.open(`${templateURL}#toolbar=0&navpanes=0&scrollbar=0`, '_blank', 'width=800,height=800');
                    }
                    
                    console.log('with uploaded file')
                } catch (error) {
                    console.log(error)
                    dispatch(setAlert({
                        show: true,
                        title: ALERT_TYPE.ERROR.toUpperCase(),
                        body: 'Error downloading the PDF.',
                    }))
                }

            }
            else {
                // generate initial PDF
                try {
                    const templateLocalPath = process.env.PUBLIC_URL + file?.LocalPath;
                    const pdfBlob = await constructFormData_toPDF(templateLocalPath, file); //plot the form data
                   
                    viewPDFFile(pdfBlob)

                } catch (error) {
                    console.log(error)
                    dispatch(setAlert({
                        show: true,
                        title: ALERT_TYPE.ERROR.toUpperCase(),
                        body: 'Error downloading the PDF.',
                    }))
                }
            }
            console.log('Completed...')

        } catch (error) {
            dispatch(setAlert({
                show: true,
                title: 'Error processing the file',
                body: 'The PDF does not exist. Please check the Local Path',
            }))
        }
    }

    const constructFormData_toPDF = async (path, file) => {

        const PDF_FILE = path;

        const fieldSignatories = getSignatories(file);

        if (!PDF_FILE) {
            dispatch(setAlert({
                show: true,
                title: 'Template Error',
                body: 'No existing PDF Template.',
            }))
            return;
        }

        try {
            // Load the PDF document
            const formPdfBytes = await fetch(PDF_FILE).then(res => res.arrayBuffer())
            const pdfDoc = await PDFDocument.load(formPdfBytes);
            //get Form Fields
            const form = pdfDoc.getForm();

            const fields = form.getFields()
            fields.forEach(async (field) => {
                const fieldName = field.getName()

                if (mainValues?.hasOwnProperty(fieldName) ||
                    agentValues?.hasOwnProperty(fieldName) ||
                    fieldSignatories?.hasOwnProperty(fieldName)
                ) {

                    const formFieldValue = (mainValues[fieldName]) && mainValues[fieldName]?.toString();
                    const agentFieldValue = (agentValues[fieldName]) && agentValues[fieldName]?.toString();
                    const fieldImg = (fieldSignatories[fieldName]) && fieldSignatories[fieldName];

                    if (
                        !(field.constructor.name === "PDFRadioGroup") &&
                        !(field.constructor.name === "PDFCheckBox" &&
                            !(field.constructor.name === "PDFButton"))
                    ) {
                        if (agentFieldValue) {
                            form.getTextField(fieldName).setText(agentFieldValue) //Agent
                        } else {
                            form.getTextField(fieldName).setText(formFieldValue) //Forms
                        }

                        if (fieldName.includes("SignedDate")) {
                            form.getTextField(fieldName).setText(fieldSignatories[fieldName]) //signatory date
                        }

                        if (fieldImg && fieldName.includes("Signature")) {
                            const sigField = form.getTextField(fieldName)
                            // const image = await fetch(fieldImg).then(res => res.arrayBuffer())
                            const embededImg = await pdfDoc.embedPng(fieldImg) //Signatories
                            sigField.setImage(embededImg)
                        }
                    }

                    // disable filled out fields.
                    field?.enableReadOnly()

                }
            })

            // Serialize the PDFDocument to bytes
            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            return blob;
        } catch (error) {
            console.log(error)
            dispatch(setAlert({
                show: true,
                title: ALERT_TYPE.ERROR,
                body: 'Error downloading the PDF.',
            }))
        }
    }


    const getSignatories = (file) => {

        const signatories = formSignatories?.find(form => form.formId === file.Id);
        const signatoryValues = signatories?.signatoryValues || []

        return signatoryValues?.reduce((acc, item) => {
            acc[item.field + 'Signature'] = item[item.field + 'Signature'];
            acc[item.field + 'SignedDate'] = item[item.field + 'SignedDate'];
            return acc;
        }, {});
    }

    const signButtonLabel = (file) => {
        //get signatory values
        const signatories = formSignatories?.find(form => form.formId === file.Id);
        const signatoryValues = signatories?.signatoryValues || []
        //check if there's open signatories
        const open = signatoryValues.find(sign => !sign.signature)

        return open || signatoryValues.length < 1 ? "sign" : "signed"
    }

    return {
        transID,
        isMounted,
        handleViewFile,
        signButtonLabel,
        sharedTemplate,
        expirationDate,
        type
    }
}

export default usePublicPDFPage;